<template>
  <div class="-process-tab">
    <keep-alive>
      <slot />
    </keep-alive>
  </div>
</template>

<script>
const COMPONENT_TAG_NAME_PAGE = 'sui-page';
const COMPONENT_TAG_NAME_PAGE_HEADER = 'sui-page-header';
const COMPONENT_TAG_NAME_PAGE_CONTENTS = 'sui-page-contents';

export default {
  name: 'SuiProcessTab',
  props: {
    // 최초 선택된 탭 인덱스 번호 (default: -1 미선택)
    // 첫번 째 보이는 탭 인덱스
    defaultTabIndex: {
      type: Number,
      default: -1,
    },

    // 탭 아이템
    // title: 탭 제목, count: 카운트, checked: 탭 체크 상태 , component: 탭 컨텐츠 컴포넌트
    tabItems: {
      type: Array,
      required: true,
    },

    // 현재 선택될 component를 설정하는 함수, slot 내부에 접근이 불가하기 때문에 외부에서 넘겨줘야 함
    setCurrentTabComponent: {
      type: Function,
      required: true,
    },

    showProcess: {
      type: Boolean,
      default: true,
    },

    showCount: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      currentTabIndex: -1,
      selectQueue: -1,
    };
  },
  mounted() {
    this.registerProcessTabItems();
  },
  methods: {
    _findPageComponent() {
      let currentComponent = this;
      while (currentComponent) {
        if (currentComponent.$options._componentTag === COMPONENT_TAG_NAME_PAGE) {
          return currentComponent;
        }
        currentComponent = currentComponent.$parent;
      }
      return null;
    },
    registerProcessTabItems() {      
      const pageComponent = this._findPageComponent();

      // page header
      const pageHeaderComponent = _.filter(pageComponent.$children, child => {
        if (child.$options._componentTag === COMPONENT_TAG_NAME_PAGE_HEADER) {
          return child;
        }
        return null;
      });
      pageHeaderComponent[0].registerProcessTabItems(this);

      // page contents
      const pageContentsComponent = _.filter(pageComponent.$children, child => {
        if (child.$options._componentTag === COMPONENT_TAG_NAME_PAGE_CONTENTS) {
          return child;
        }
        return null;
      });
      pageContentsComponent[0].registerProcessTabItems(this);
    },
    isPageComponent(component) {
      if (typeof component === 'string' && component.length === 13) {
        const splittedStr = component.split('_');
        if (splittedStr.length === 3 && splittedStr[0] === 'PGE') {
          return true;
        }
      } else if (typeof component === 'function') {
        return true;
      }
      return false;
    },
    loadTabComponent(currentTabIndex) {
      const { component } = this.tabItems[currentTabIndex];
      if (!component) {
        return;
      }
      if (this.isPageComponent(component)) {
        utils.loadPageMeta(component)
          .then(() => {
            this.setCurrentTabComponent(component);
            this.$nextTick(()=>{
              this.$emit('component-changed', component);
            })
          })
          .catch(error => {
            // load fail
          });
      } else {
        this.setCurrentTabComponent(component);
        this.$nextTick(()=>{
          this.$emit('component-changed', component);
        })
      }
    },
    setSelectFunction(selectFunction) {
      this.selectFunction = selectFunction;
      if (this.selectQueue >= 0) {
        this.selectFunction(this.selectQueue);
        this.selectQueue = -1;
      } 
    },
    select(index) {
      if (this.selectFunction) {
        this.selectFunction(index);
      } else {
        this.selectQueue = index;
      }
    },
    onComponentMounted(component) {
      console.log(component.$options.name);
    },
  },
};
</script>

<style scoped>
</style>
